import { createFileRoute, redirect } from '@tanstack/react-router';

export const Route = createFileRoute('/_auth/operator/services')({
  beforeLoad: () => {
    throw redirect({ to: '/operator/catalog' });
  },
  component: () => null,
});
